import { render, staticRenderFns } from "./RegisterRoute.vue?vue&type=template&id=646adf0e&scoped=true"
import script from "./RegisterRoute.vue?vue&type=script&lang=js"
export * from "./RegisterRoute.vue?vue&type=script&lang=js"
import style0 from "./RegisterRoute.vue?vue&type=style&index=0&id=646adf0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646adf0e",
  null
  
)

export default component.exports